import queryString from 'querystring';
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('TAG_MODERATIONS_CATEGORIES_MODE_LIST').plugin(axiosPlugin, {template: "array"});
let fetchAction = redux.fetchActionGet();


export const TYPES = redux.types;

export const fetchCategoriesModeList = (query) => fetchAction(`/tag-moderations/categories?${queryString.stringify(query)}`);
export const resetCategoriesModeList = () => redux.actions.reset();

export const categoriesModeList = redux.reducer();